"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Direction = void 0;
/**
 * Direction represents one, or more directions (a single, or multi direction)
 * Center represents a lack of direction
 */
var Direction;
(function (Direction) {
    // Individual Flags
    Direction[Direction["Center"] = 0] = "Center";
    Direction[Direction["Northwest"] = 128] = "Northwest";
    Direction[Direction["North"] = 64] = "North";
    Direction[Direction["Northeast"] = 32] = "Northeast";
    Direction[Direction["West"] = 16] = "West";
    Direction[Direction["East"] = 8] = "East";
    Direction[Direction["Southwest"] = 4] = "Southwest";
    Direction[Direction["South"] = 2] = "South";
    Direction[Direction["Southeast"] = 1] = "Southeast";
    // Premade combinations for convenience
    Direction[Direction["All"] = 255] = "All";
    Direction[Direction["Cardinals"] = 90] = "Cardinals";
    Direction[Direction["Diagonals"] = 165] = "Diagonals";
    Direction[Direction["NorthAndSouth"] = 66] = "NorthAndSouth";
    Direction[Direction["WestAndEast"] = 24] = "WestAndEast";
    Direction[Direction["WestAndNorth"] = 80] = "WestAndNorth";
    Direction[Direction["WestAndSouth"] = 18] = "WestAndSouth";
    Direction[Direction["EastAndNorth"] = 72] = "EastAndNorth";
    Direction[Direction["EastAndSouth"] = 10] = "EastAndSouth";
})(Direction || (exports.Direction = Direction = {}));
